module.exports = "/static/media/logo-phone-by-webcom-loader.8aa6feb9.svg";